import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu--sprite",
  "use": "menu--sprite-usage",
  "viewBox": "0 0 40 26",
  "content": "<symbol viewBox=\"0 0 40 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu--sprite\">\n<path d=\"M0 24H40\" stroke=\"#FE5000\" stroke-width=\"4\" />\n<path d=\"M0 13H40\" stroke=\"#E6B10E\" stroke-width=\"4\" />\n<path d=\"M0 2H40\" stroke=\"#98EDCE\" stroke-width=\"4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol